<template>
  <div class="step" :style="{ background: siteSettings.background }">
    <Heading :text="siteSettings.leadCaptureTitle" />
    <form @submit.prevent="prepareDataAndSave">
      <div class="listItem" v-if="showName">
        <label for="userName" :style="{ color: siteSettings.textColor }">{{
          nameLabel
        }}</label>
        <input required type="text" name="name" />
      </div>
      <div class="listItem" v-if="showEmail">
        <label for="userEmail" :style="{ color: siteSettings.textColor }">{{
          emailLabel
        }}</label>
        <input required type="email" name="email" />
      </div>
      <button>
        Submit
      </button>
    </form>
    <Debug />
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import Heading from "./Heading";
import Debug from "./Debug.vue";
export default {
  name: "GetUserDetails",
  components: {
    Debug,
    Heading
  },
  computed: {
    ...mapState([
      "siteSettings",
      "matrixArray",
      "userProductResults",
      "productAnswersArray",
      "siteSettings",
      "likeliestProductsList",
      "products"
    ]),
    showName() {
      return (
        this.siteSettings.leadCaptureFields &&
        this.siteSettings.leadCaptureFields.name &&
        this.siteSettings.leadCaptureFields.name.enable
      );
    },
    nameLabel() {
      return this.showName
        ? this.siteSettings.leadCaptureFields.name.label
        : "";
    },
    showEmail() {
      return (
        this.siteSettings.leadCaptureFields &&
        this.siteSettings.leadCaptureFields.email &&
        this.siteSettings.leadCaptureFields.email.enable
      );
    },
    emailLabel() {
      return this.showEmail
        ? this.siteSettings.leadCaptureFields.email.label
        : "";
    }
  },
  methods: {
    ...mapActions(["generateProducts"]),
    ...mapMutations(["setUser"]),
    async prepareDataAndSave(submitEvent) {
      const form = new FormData(submitEvent.target);
      const user = {
        email: form.get("email"),
        name: form.get("name")
      };
      this.setUser(user);
      await this.generateProducts();
    }
  }
};
</script>

<style lang="scss" scoped>
.step {
  width: inherit;
  height: inherit;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // justify-content: center;
  form {
    width: inherit;
    height: inherit;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .listItem {
      text-align: center;
      width: calc(100%-50px);
      display: inline-flex;
      justify-content: center;
      background: inherit;
      margin: 10px;
      // border: 2px solid white;
      cursor: pointer;
      box-shadow: inset 0 0 0 2px rgba(15, 78, 99, 0),
        2px 4px 7px rgba(0, 0, 0, 0.11);
      text-decoration: none;
      color: inherit;
      flex-direction: column;
      align-items: center;
      input {
        // border: none;
        width: 99%;
        height: 30px;
      }
    }
    .submitIcon {
      height: 30px;
      cursor: pointer;
    }
    button {
      padding: 15px;
      text-decoration: none;
      color: #fff;
      background-color: #08c;
      border: none;
      outline: none;
      cursor: pointer;
      &:disabled {
        opacity: 0.5;
      }
    }
  }
  .notice {
    color: red;
  }
}
</style>
